import React, { memo, useEffect, useState } from 'react'

import { Button, Icon, Close } from '@cgtrader/triangle-ui/dist/src/ssr-index'

import { iconSize } from 'Pods/ThreeDStudio/constants'
import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'

const DISMISSED_KEY = 'aiAssistantNewImageNoteDismissed'

const isDismissed = () => {
  try {
    return window.localStorage.getItem(DISMISSED_KEY) === '1'
  } catch (_) {
    return false
  }
}

const dismiss = () => {
  try {
    window.localStorage.setItem(DISMISSED_KEY, '1')
  } catch (_) {
    // Storage may be unavailable (private mode, quota). Treat as no-op.
  }
}

const closeIcon = <Icon svgComponent={Close} size={iconSize} notSpaced />

// Reminds users that the next prompt creates a new image rather than editing the last
// one. Rendered above the Create composer once an image exists; dismissing it is
// remembered across sessions.
function NewImageNote() {
  const t = useTranslation()
  const [isVisible, setIsVisible] = useState(false)

  // Storage is read in an effect so the SSR markup matches the first client render.
  useEffect(() => {
    setIsVisible(!isDismissed())
  }, [])

  if (!isVisible) {
    return null
  }

  const handleClose = () => {
    dismiss()
    setIsVisible(false)
  }

  return (
    <div className="image-assistant-panel__note" role="status">
      <p className="image-assistant-panel__note-text cgt-caption">
        {t('imageAssistantPanel.createTab.newImageNote')}
      </p>
      <Button
        type="ghost"
        variant="only-icon"
        size="tiny"
        actionType="button"
        customClass="image-assistant-panel__note-close"
        icon={closeIcon}
        aria-label="Dismiss"
        onClick={handleClose}
      />
    </div>
  )
}

export default memo(NewImageNote)
